import React from 'react';
import { AlertTriangle, LoaderCircle } from 'lucide-react';
import { useI18n } from '../../hooks/useI18n';
import { Button } from '../../components/ui/Button';
import { Modal } from '../../components/ui/Modal';

export const DeleteChatModal = ({ open, chat, loading, isLastChat, onClose, onConfirm }) => {
  const { t } = useI18n();

  if (!chat) {
    return null;
  }

  const handleClose = () => {
    if (loading) {
      return;
    }

    onClose();
  };

  const chatLabel = chat.title || t('defaultTaskTitle');

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeDisabled={loading}
      title={t('deleteChatTitle')}
      panelClassName="max-w-md rounded-[1.75rem] p-5"
      contentClassName="mb-4"
      titleClassName="text-base"
    >
      <div className="space-y-5">
        <div className="flex gap-3 rounded-2xl border border-rose-200/80 bg-rose-50/70 p-4 dark:border-rose-500/20 dark:bg-rose-500/10">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-rose-100 text-rose-600 dark:bg-rose-500/20 dark:text-rose-200">
            <AlertTriangle size={18} />
          </span>
          <p className="text-sm leading-6 text-muted">
            {isLastChat
              ? t('deleteChatLastWarning')
              : t('deleteChatConfirm', { name: chatLabel })}
          </p>
        </div>

        <div className="flex justify-end gap-3">
          <Button type="button" variant="secondary" onClick={handleClose} disabled={loading}>
            {t('cancel')}
          </Button>
          <Button type="button" variant="danger" onClick={onConfirm} disabled={loading || isLastChat}>
            {loading ? (
              <>
                <LoaderCircle size={16} className="animate-spin" />
                {t('deletingChat')}
              </>
            ) : (
              t('delete')
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
